module.exports = __webpack_public_path__ + "img/avatar-05-140x140.10f0f47a.png";